// @flow

export type DisputeResultNew = 1;
export type DisputeResultAccepted = 2;
export type DisputeResultNeedProof = 3;
export type DisputeResultProofSent = 4;
export type DisputeResultNeedAddProof = 5;
export type DisputeResultNoActionsRequired = 6;
export type DisputeResultWon = 7;
export type DisputeResultLost = 8;
export type DisputeResult =
  | DisputeResultNew
  | DisputeResultAccepted
  | DisputeResultNeedProof
  | DisputeResultProofSent
  | DisputeResultNeedAddProof
  | DisputeResultNoActionsRequired
  | DisputeResultWon
  | DisputeResultLost;

export type PerPage = 100;

export type DisputeSortDirectionUndefined = '';
export type DisputeSortDirectionAsc = 'asc';
export type DisputeSortDirectionDesc = 'desc';
export type DisputeSortDirection =
  | DisputeSortDirectionUndefined
  | DisputeSortDirectionAsc
  | DisputeSortDirectionDesc;

export const DISPUTE_SORT_DIRECTION_UNDEFINED = '';
export const DISPUTE_SORT_DIRECTION_ASC = 'asc';
export const DISPUTE_SORT_DIRECTION_DESC = 'desc';

export type DisputeSortFieldDefault = '';
export type DisputeSortFieldTransactionDate = 'transactionDate';
export type DisputeSortFieldDisputeDate = 'disputeDate';
export type DisputeSortField =
  | DisputeSortFieldDefault
  | DisputeSortFieldTransactionDate
  | DisputeSortFieldDisputeDate;

export const DISPUTE_SORT_FIELD_DEFAULT = '';
export const DISPUTE_SORT_FIELD_TRANSACTION_DATE = 'transactionDate';
export const DISPUTE_SORT_FIELD_DISPUTE_DATE = 'disputeDate';

export type DisputeSort = {
  field: DisputeSortField,
  dir: DisputeSortDirection
};

export type NameValue = {
  name: string,
  value: string
};

export type DictionaryItem = {
  id: number | string,
  name?: string
};

export type Amount = {
  value: number,
  currency: string
};

export type PartnerEvidence = {
  status: string,
  days_left: number,
  response_text: string,
  partner_files?: Array<{
    id: string,
    name: string
  }>
};

export type Dispute = {
  id: number,
  paymentMethod: DictionaryItem,
  instance: DictionaryItem,
  transaction: {
    id: number,
    date: Date,
    status: number,
    amount: Amount,
    countryCode: string
  },
  projectID: number,
  incomingDate: Date,
  user: {
    v1: string,
    email: string
  },
  reason?: DictionaryItem,
  status: DictionaryItem,
  result: DisputeResult,
  type?: DictionaryItem,
  description: string,
  fee: Amount,
  isFinal: boolean,
  partner_evidence_status?: string
};

export type ProofFile = {
  fileId: string,
  fileName: string
};

export type PaymentMethod = {
  paymentMethod: DictionaryItem,
  reasons: Array<DictionaryItem>,
  instances: Array<DictionaryItem>
};

export type DateTime = {
  date: string,
  time: string
};

export type SearchFilters = {
  period: {
    from?: Date,
    to?: Date
  },
  projects: Array<number>,
  instances: Array<number>,
  reasons: Array<number>,
  results: Array<number>,
  userId?: string,
  partnerEvidenceRequestStatus?: string
};

export type DisputeRow = {
  transaction: {
    id: number,
    status: number,
    date: {
      local: string,
      cst: string
    }
  },
  project: DictionaryItem,
  paymentMethod: string,
  userDetails: DictionaryItem,
  countryCode: string,
  transactionAmount: Amount,
  fee: Amount,
  incomingDate: DateTime,
  reason?: string,
  type?: string,
  description: string,
  status: string,
  result: DisputeResult,
  partner_evidence_status?: string
};

type FeatureUserProtection = 'user_protection';
export type FeatureName = FeatureUserProtection;

export type Feature = {
  name: FeatureName,
  enabled: boolean
};

export type Features = Array<Feature>;

export type FeaturesState = {
  features: Features,
  isFetching: boolean
};
